module.exports = __webpack_public_path__ + "static/media/applications-permits-laser.fc8025be.svg";